import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      HOW_IT_WORKS: "Slik fungerer det",
      INGREDIENTS_YOU: "Ingredienser du",
      DO_NOT: "ikke",
      WANT: "vil ha",
      OPTIONAL: "valgfritt",
      WE_WILL_DO_OUR_BEST_TO_AVOID_THESE_INGREDIENTS:
        "Vi vil gjøre vårt beste for å unngå å foreslå noe du ikke liker eller ikke vil ha.",
      IS_THERE_ANYTHING_ELSE_YOU_DO_NOT_WANT:
        "Er det andre ingredienser du ikke vil ha?",
      MAKE_SURE_TO_READ_RECIPES:
        "Sørg for å lese gjennom ingredienslisten før du velger rettene dine. Allergener er markert.",
      BY_SAVING_YOU_ACCEPT_TERMS_AND_CONDITIONS:
        "Ved å lagre valgene dine aksepterer du at vi lagrer opplysninger om hva slags mat du liker, ikker liker, samt eventuelle allergier.",
      TERMS_AND_CONDITIONS: "Vilkår og betingelser",
      SELECT_SIZE: "Velg størrelse",
      PRO_TIP: "Tips!",
      IF_YOU_WANT_TO_CHOOSE_FULL_RANGE:
        "Hvis du vil velge blant alle rettene, kan du oppgradere til 2 personer",

      SAVE_CHANGES: "Lagre endringer",
      SELECTED_A_MIX: "Du har valgt en blanding av ulike typer retter.",
      WHAT_DISHES_DO_YOU_LIKE: "Hvilken type retter liker du?",
      FULL_MENU_IS_ALWAYS_AVAILABLE:
        "Du kan alltid bestille fra den fullstendige menyen - valgene dine hjelper oss å tilpasse din opplevelse.",
      CANNOT_DESELECT_INGREDIENTS:
        "Du kan ikke velge bort ingredienser i den ferdige matkassen, men du kan bytte retter.",
      OR_SELECT_FIXED:
        "Eller velg en ferdig matkasse, og la oss velge retter for deg",
      YOU_HAVE_SELECTED_FIXED:
        "Du har valgt en ferdig matkasse. Denne kan ikke kombineres med andre preferanser.",
      CANCEL: "Avbryt",
    },
    se: {
      HOW_IT_WORKS: "Så fungerar det",
      INGREDIENTS_YOU: "Ingredienser du",
      DO_NOT: "inte",
      WANT: "vill ha",
      OPTIONAL: "valfritt",
      WE_WILL_DO_OUR_BEST_TO_AVOID_THESE_INGREDIENTS:
        "Vi gör vårt bästa för att undvika rätter med ingredienser du inte gillar eller vill ha.",
      IS_THERE_ANYTHING_ELSE_YOU_DO_NOT_WANT:
        "Finns det andra ingredienser du vill undvika?",
      MAKE_SURE_TO_READ_RECIPES:
        "Allergener är markerade i alla recept – läs noga innan du väljer rätter.",
      BY_SAVING_YOU_ACCEPT_TERMS_AND_CONDITIONS:
        "Genom att spara dina preferenser godkänner du att vi lagrar information om vilken mat du gillar, ogillar och eventuella allergener.",
      TERMS_AND_CONDITIONS: "Villkor och bestämmelser",
      SELECT_SIZE: "Välj storlek",

      // Specific for NO singel
      PRO_TIP: "",
      IF_YOU_WANT_TO_CHOOSE_FULL_RANGE: "",

      SAVE_CHANGES: "Spara ändringar",
      SELECTED_A_MIX: "Du har valt en blandning av olika typer av rätter.",
      WHAT_DISHES_DO_YOU_LIKE: "Vilken typ av rätter gillar du?",
      FULL_MENU_IS_ALWAYS_AVAILABLE:
        "Den fullständiga menyn finns alltid tillgänglig att beställa från – dina val hjälper oss enbart att anpassa din upplevelse.",
      CANNOT_DESELECT_INGREDIENTS:
        "Du kan inte välja bort ingredienser i matkassen med förvalda rätter, men du kan byta rätter.",
      OR_SELECT_FIXED: "Eller välj en matkasse med förvalda rätter",
      YOU_HAVE_SELECTED_FIXED:
        "Du har valt en matkasse med förvalda rätter, som inte kan kombineras med fler preferenser.",
      CANCEL: "Avbryt",
    },
    dk: {
      HOW_IT_WORKS: "Sådan fungerer det",
      INGREDIENTS_YOU: "Ingredienser du",
      DO_NOT: "ikke",
      WANT: "ønsker",
      OPTIONAL: "valgfrit",
      WE_WILL_DO_OUR_BEST_TO_AVOID_THESE_INGREDIENTS:
        "Vi vil gøre vores bedste for at undgå at foreslå noget, du enten ikke kan lide eller ikke ønsker.",
      IS_THERE_ANYTHING_ELSE_YOU_DO_NOT_WANT: "Er der andet, du ikke ønsker?",
      MAKE_SURE_TO_READ_RECIPES:
        "Sørg for at læse opskrifternes ingrediensliste igennem, før du vælger retter. Allergener er fremhævet.",
      BY_SAVING_YOU_ACCEPT_TERMS_AND_CONDITIONS:
        "Ved at gemme dine præferencer accepterer du, at vi gemmer oplysninger om, hvilken slags mad du kan lide, ikke kan lide samt eventuelle allergener.",
      TERMS_AND_CONDITIONS: "Vilkår og betingelser.",
      SELECT_SIZE: "Vælg størrelse",

      // Specific for NO singel
      PRO_TIP: "",
      IF_YOU_WANT_TO_CHOOSE_FULL_RANGE: "",

      SAVE_CHANGES: "Gem ændringer",
      SELECTED_A_MIX: "Du har valgt en blanding af forskellige typer retter.",
      WHAT_DISHES_DO_YOU_LIKE: "Hvilken type retter kan du lide?",
      FULL_MENU_IS_ALWAYS_AVAILABLE:
        "Husk, at du altid kan vælge retter fra den fulde menu. Kategorierne nedenfor hjælper os blot med at forbedre dine menuforslag.",
      CANNOT_DESELECT_INGREDIENTS:
        "Du har valgt en færdig måltidskasse. Kan ikke kombineres med andre præferencer.",
      OR_SELECT_FIXED:
        "Eller vælg en færdig måltidskasse med forvalgte retter.",
      YOU_HAVE_SELECTED_FIXED:
        "Du kan ikke fravælge ingredienser i den færdige måltidskasse, men du kan ændre retter.",
      CANCEL: "Annuller",
    },
  } as const
)[language];
